import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Form, Grid, Message, Button } from 'semantic-ui-react'
import DropDown from '../../../../commonComponents/formComponents/dropDown'
import { useUpdateEffect } from '../../../../hooks'
import { useCurrentShipmentType } from '../../../../hooks/useCurrentShipmentType'
import { TranslateContext } from '../../TranslateContext'
import FieldValue from './fieldValue'
import MerchList from './MerchList'
import InvList from './InvList'
import { FIELD_NAMES, MASS_UPDATE_OPTIONS } from './constants'
import { saveMassUpdateData } from '../../../api/saveNLdata'
import { useValidation } from '../../../hooks/useValidation'
import { CustomLoader } from '../../../../commonComponents/formComponents/loader'
import { showToast } from '../../../../commonComponents/showToast'
import * as ActionTypes from '../../../actions/actionTypes'

const MassUpdate = () => {

    const dispatch = useDispatch()
    const [isLoading, setLoader] = useState(false)
    const { initItemsTabValidation } = useValidation('items')

    const { isDMS, isImportShipment, isDisabled } = useCurrentShipmentType()

    if (isDMS && isImportShipment) return null

    const translate = React.useContext(TranslateContext).translate

    const FIELD_NAMES_Filtered = FIELD_NAMES.filter((itm) => {
        return itm?.status?.includes(isImportShipment ? 'IMPORT' : 'EXPORT')
            && itm?.shipmentStatus?.includes(isDMS ? 'DMS' : 'AGS')
    })

    const [fieldName, setFieldName] = useState({})
    const [fieldValue, setFieldValue] = useState('')
    const [option, setOption] = useState('')
    const [invoiceOption, setInvoiceOption] = useState({})
    
    const invoiceList = useSelector((state) => {
        return state.InvoicesReducer?.invoices?.map((itm, idx) => ({
            id: itm?.invoiceId,
            text: itm?.invoiceNum || `NA`,
            value: `00${idx + 1}`,
            isChecked: itm?.isChecked
        }))
    })

    const merchList = useSelector(state => {
        if (!Array.isArray(invoiceOption) && invoiceOption?.id) {
            return state.InvoicesReducer.lineItems?.[invoiceOption?.id]?.map((itm, idx) => ({
                id: itm?.merchandiseId,
                title: `LINE-ITEM-00${idx + 1}`,
                isChecked: itm?.isChecked
            }))
        }
        return []
    })

    useUpdateEffect(() => {
        setFieldValue('')
    }, [fieldName])

    useUpdateEffect(() => {
        setOption('')
    }, [fieldValue])

    useUpdateEffect(() => {
        if (option == '1') setInvoiceOption([])
        else setInvoiceOption({})
    }, [option])

    const applyMassUpdate = async () => {
        setLoader(true)
        if (option == '1') {
            const invoiceIDs = invoiceList?.filter((inv) => inv.isChecked).map((inv) => inv?.id)
            const response = await saveMassUpdateData({
                invoiceIDs: invoiceIDs,
                lineItem: { [`${fieldName?.key}`]: fieldValue }
            })
            if (response?.data?.eventMessage?.responseCode == '200') {
                dispatch({
                    type: ActionTypes.MASS_UPDATE_FOR_MULTIPLE_INVOICE,
                    payload: {
                        invoiceIDs: invoiceIDs,
                        params: { [`${fieldName?.key}`]: fieldValue }
                    }
                })
            } else showToast(translate('SOMETHING_WENT_WRONG'))
        }
        if (option == '2') {
            const invoiceIDs = invoiceList?.map((inv) => inv?.id)
            const response = await saveMassUpdateData({
                lineItem: { [`${fieldName?.key}`]: fieldValue }
            })
            if (response?.data?.eventMessage?.responseCode == '200') {
                dispatch({
                    type: ActionTypes.MASS_UPDATE_FOR_MULTIPLE_INVOICE,
                    payload: {
                        invoiceIDs: invoiceIDs,
                        params: { [`${fieldName?.key}`]: fieldValue }
                    }
                })
            } else showToast(translate('SOMETHING_WENT_WRONG'))
        }
        if (option == '3') {
            const merchandiseIDs = merchList?.filter((merch) => merch.isChecked).map((merch) => merch?.id)
            const response = await saveMassUpdateData({
                merchandiseIDs: merchandiseIDs,
                lineItem: { [`${fieldName?.key}`]: fieldValue }
            })
            if (response?.data?.eventMessage?.responseCode == '200') {
                dispatch({
                    type: ActionTypes.MASS_UPDATE_AT_INVOICE_LEVEL,
                    payload: {
                        invoiceId: invoiceOption?.id,
                        merchandiseIDs: merchandiseIDs || [],
                        params: { [`${fieldName?.key}`]: fieldValue }
                    }
                })
            } else showToast(translate('SOMETHING_WENT_WRONG'))
        }
        dispatch(initItemsTabValidation())
        setLoader(false)
    }


    return (
        <div style={{ marginTop: '10px', marginBottom:'10px' }}>
            <Message>
                {isLoading && <CustomLoader />}
                <div style={{ display: 'flex' }}>
                    <h4>{translate("MASS_UPDATE")}</h4>
                    <div style={{ marginLeft: 'auto' }}>
                        {(option == '1') && (
                            <>
                                <span>{translate("INVOICES")} : </span>
                                {invoiceList?.map((itm, idx) => itm.isChecked ? <span>00{idx + 1}, </span> : '')}
                            </>
                        )}
                        {(option == '3' && invoiceOption?.id) && (
                            <>
                                <span>{translate("LINE_ITEMS")} : </span>
                                {merchList?.map((itm, idx) => itm.isChecked ? <span>00{idx + 1}, </span> : '')}
                            </>
                        )}
                    </div>
                </div>
                <Form.Group className='float-container mg-t-15' widths='equal'>
                    <Grid className='kn__grid'>
                        <Grid.Row>
                            <Grid.Column width={4} className='divFormFeild'>
                                <DropDown
                                    id={`field`}
                                    label={translate('FIELD', { ns: ['default', 'FIELD'] })}
                                    disabled={isDisabled}
                                    className='field-bg dropdown100'
                                    labelClass='text-none'
                                    isLabel={true}
                                    clearable
                                    data={FIELD_NAMES_Filtered}
                                    value={fieldName?.value}
                                    onChange={(value) => {
                                        const data = FIELD_NAMES_Filtered.find((itm) => itm?.value === value)
                                        setFieldName(data)
                                    }}
                                />
                            </Grid.Column>
                            {fieldName?.value && (
                                <Grid.Column width={3} className='divFormFeild'>
                                    <FieldValue
                                        fieldName={fieldName}
                                        fieldValue={fieldValue}
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid.Column>
                            )}
                            {fieldValue?.trim() && (
                                <Grid.Column width={3} className='divFormFeild'>
                                    <DropDown
                                        id={`options`}
                                        label={translate('OPTIONS', { ns: ['default', 'OPTIONS'] })}
                                        className='field-bg dropdown100'
                                        labelClass='text-none'
                                        direction='left'
                                        clearable
                                        data={MASS_UPDATE_OPTIONS}
                                        value={option}
                                        disabled={!fieldValue?.trim()}
                                        onChange={(value) => {
                                            setOption(value)
                                        }}
                                    />
                                </Grid.Column>
                            )}
                            <Grid.Column width={3} className='divFormFeild'>
                                {option == '1' && (<InvList />)}
                                {option == '3' && (
                                    <DropDown
                                        id={`invoiceList`}
                                        label={translate('INVOICE', { ns: ['default', 'INVOICE'] })}
                                        className='field-bg dropdown100'
                                        labelClass='text-none'
                                        direction='left'
                                        clearable
                                        data={invoiceList}
                                        value={Array.isArray(invoiceOption) ? '' : invoiceOption?.value}
                                        disabled={!option?.trim()}
                                        onChange={(value) => {
                                            const data = invoiceList?.find(itm => itm?.value === value)
                                            setInvoiceOption(data)
                                        }}
                                    />
                                )}
                            </Grid.Column>
                            {(option == '3' && invoiceOption?.value) && (
                                <Grid.Column width={3} className='divFormFeild'>
                                    <MerchList invoiceOption={invoiceOption} />
                                </Grid.Column>
                            )}
                        </Grid.Row>
                    </Grid>
                </Form.Group>
                <div style={{ textAlign: 'right', marginTop: '10px' }}>
                    {((option == '1' && invoiceList?.some((i) => i.isChecked))
                        || option == '2'
                        || (option == '3' && merchList?.some((m) => m.isChecked)))
                        && (
                            <Button
                                size="mini"
                                className='sv todo-button'
                                style={{ margin: '0px' }}
                                onClick={() => applyMassUpdate()}
                            >
                                {translate("APPLY")}
                            </Button>
                        )}
                </div>
            </Message>
        </div>
    )
}

export default MassUpdate

